export default "__VITE_ASSET__B8lTuX4Z__"